import React, { useState } from "react";
import {
    Alert,
    Box,
    Tab,
    Tabs,
    Typography,
} from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import DashboardLayout from "../../layouts/Dashboard";
import { PageContainer, PageHeader } from "../../components";
import { checkRoles } from "../../functions/checkRoles";
import { ADMIN_PANEL_ENTITIES } from "./adminPanelConfig";
import EntityStatusManager from "./EntityStatusManager";

function TabPanel({ children, value, index }) {
    if (value !== index) return null;
    return <Box sx={{ pt: 3 }}>{children}</Box>;
}

export default function AdminPanel() {
    const [tab, setTab] = useState(0);
    const isSuperAdmin = checkRoles("SuperAdministrator");

    if (!isSuperAdmin) {
        return (
            <DashboardLayout>
                <PageContainer>
                    <Alert severity="error" variant="outlined">
                        Раздел «Админ панель» доступен только суперадминистратору.
                    </Alert>
                </PageContainer>
            </DashboardLayout>
        );
    }

    return (
        <DashboardLayout>
            <PageHeader heading="Админ панель">
                <AdminPanelSettingsIcon color="primary" sx={{ fontSize: 32 }} />
            </PageHeader>
            <PageContainer>
                <Alert severity="info" variant="outlined" sx={{ mb: 3 }}>
                    Управление статусами документов без прямого доступа к базе данных.
                    Найдите документ по ID или номеру, выберите новый статус и подтвердите изменение.
                </Alert>

                <Box
                    sx={{
                        borderBottom: 1,
                        borderColor: "divider",
                        bgcolor: "background.paper",
                        borderRadius: "8px 8px 0 0",
                    }}
                >
                    <Tabs
                        value={tab}
                        onChange={(_, v) => setTab(v)}
                        variant="scrollable"
                        scrollButtons="auto"
                        sx={{
                            px: 1,
                            "& .MuiTab-root": {
                                textTransform: "none",
                                fontWeight: 500,
                                minHeight: 52,
                            },
                        }}
                    >
                        {ADMIN_PANEL_ENTITIES.map((entity) => (
                            <Tab key={entity.key} label={entity.label} />
                        ))}
                    </Tabs>
                </Box>

                <Box
                    sx={{
                        p: 0,
                        bgcolor: "background.paper",
                        borderRadius: "0 0 8px 8px",
                        border: "1px solid",
                        borderColor: "divider",
                        borderTop: 0,
                        px: 3,
                        pb: 3,
                    }}
                >
                    {ADMIN_PANEL_ENTITIES.map((entity, index) => (
                        <TabPanel key={entity.key} value={tab} index={index}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                                {entity.label}
                            </Typography>
                            <EntityStatusManager entity={entity} />
                        </TabPanel>
                    ))}
                </Box>
            </PageContainer>
        </DashboardLayout>
    );
}
